import { useTranslation } from 'react-i18next';
import React from "react";
import { Description } from "@/erp_subpackage/components/YhBox/Description";
import useGlobalModel from "@/erp_subpackage/model/globalModel";
import { usePurchasePoDetailsModel } from "./purchasePoDetailModel";
import { formatNum } from "@/erp_subpackage/utils/util";

export const FixedBottom = ({ modeKey, mode, rowCode, dispatch }) => {
    const { t } = useTranslation();
    const { collapsed } = useGlobalModel(({ collapsed }) => [collapsed]);
    const { addDesc, editDesc, lookDesc } = usePurchasePoDetailsModel();
    const typeDesc = {
        add: addDesc,
        edit: editDesc,
        look: lookDesc
    }
    const orderStatistics = [
        {
            label: t(`purchase.detail.FixedBottoms.采购项数`),
            value: typeDesc[mode].itemNumAll,
            color: "red",
            status: true
        },
        {
            label: t(`purchase.detail.FixedBottoms.采购数量`),
            value: formatNum(typeDesc[mode].numAll),
            color: "red",
            status: true
        },
        {
            label: t(`purchase.detail.FixedBottoms.采购总金额`),
            value: formatNum(typeDesc[mode].totalAll),
            color: "red",
            status: true
        },
    ]
    return (
        <div className="details-bot-fixed-warp" style={{ width: `calc(100% - ${collapsed ? '80px' : '200px'})`, paddingLeft: "43px" }}>
            {orderStatistics.map((item, index) => <Description key={index} {...item} />)}
        </div>
    )
}